"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionCalculator = void 0;
const boundingBox_1 = require("../boundingBox");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const dimension_1 = require("./dimension");
const util_1 = require("../polygon/util");
class DimensionCalculator {
    constructor(drawscale) {
        this._drawscale = drawscale;
    }
    compute(pipeNodeGroups, polygonSegs_local, doors, coordinateUtil) {
        let points_local = new Array();
        for (let pipeNodeGroup of pipeNodeGroups) {
            for (let node of pipeNodeGroup._childPipeNodes) {
                points_local.push(coordinateUtil.transformPointToLocal(node._point));
            }
        }
        let doors_local = new Array();
        for (let door of doors) {
            doors_local.push(coordinateUtil.transformLineSegmentToLocal(door));
        }
        let boundingBox = new boundingBox_1.BoundingBox();
        for (let seg of polygonSegs_local) {
            boundingBox.expand(seg.p0);
            boundingBox.expand(seg.p1);
        }
        let rowManager = new RowOrColManager(true);
        let colManager = new RowOrColManager(false);
        for (let point of points_local) {
            rowManager.add(point, point.y);
            colManager.add(point, point.x);
        }
        //排序
        for (let row of rowManager._arr) {
            row.sortPoints();
        }
        for (let col of colManager._arr) {
            col.sortPoints();
        }
        let dimensionArr = this.computeRowDimensions(rowManager, boundingBox, polygonSegs_local, doors_local, coordinateUtil);
        dimensionArr = dimensionArr.concat(this.computeColDimensions(colManager, boundingBox, polygonSegs_local, doors_local, coordinateUtil));
        return dimensionArr;
    }
    computeRowDimensions(rowManager, boundingBox, polygonSegs_local, doors_local, coordinateUtil) {
        let rowDimensionArr = new Array();
        for (let i = 0; i < rowManager._arr.length; i++) {
            let row = rowManager._arr[i];
            for (let point of row._points) {
                //朝下
                let downCalculatedSegArr = polygonSegs_local.concat();
                for (let j = i - 1; j >= 0; j--) {
                    downCalculatedSegArr.push(rowManager._arr[j].getLineSegment());
                }
                let downSeg = new LineSegment_js_1.default(point.x, point.y, point.x, boundingBox.min.y - 10); //这里和下面的10都是稍微延长一点点，避免求交失败
                let downClosestPoint = this.getClosestIntersectPoint(point, downSeg, downCalculatedSegArr);
                if (!downClosestPoint)
                    return [];
                rowDimensionArr.push(new dimension_1.Dimension(point, downClosestPoint, boundingBox.getCenter(), this._drawscale));
                //朝上
                let upCalculatedSegArr = polygonSegs_local.concat();
                for (let j = i + 1; j < rowManager._arr.length; j++) {
                    upCalculatedSegArr.push(rowManager._arr[j].getLineSegment());
                }
                let upSeg = new LineSegment_js_1.default(point.x, point.y, point.x, boundingBox.max.y + 10);
                let upClosestPoint = this.getClosestIntersectPoint(point, upSeg, upCalculatedSegArr);
                if (!upClosestPoint)
                    return [];
                rowDimensionArr.push(new dimension_1.Dimension(point, upClosestPoint, boundingBox.getCenter(), this._drawscale));
            }
        }
        this.adjustDimensionsToDoor(rowDimensionArr, polygonSegs_local, doors_local);
        this.removeRepetitiveDimension(rowDimensionArr, true);
        //转出去前转为世界坐标系
        for (let dimension of rowDimensionArr) {
            dimension._point0 = coordinateUtil.transformPointToWorld(dimension._point0);
            dimension._point1 = coordinateUtil.transformPointToWorld(dimension._point1);
            dimension._dim_point = coordinateUtil.transformPointToWorld(dimension._dim_point);
            dimension._text_pos = coordinateUtil.transformPointToWorld(dimension._text_pos);
        }
        return rowDimensionArr;
    }
    computeColDimensions(colManager, boundingBox, polygonSegs_local, doors_local, coordinateUtil) {
        let colDimensionArr = new Array();
        for (let i = 0; i < colManager._arr.length; i++) {
            let col = colManager._arr[i];
            for (let point of col._points) {
                //朝左
                let leftCalculatedSegArr = polygonSegs_local.concat();
                for (let j = i - 1; j >= 0; j--) {
                    leftCalculatedSegArr.push(colManager._arr[j].getLineSegment());
                }
                let leftSeg = new LineSegment_js_1.default(point.x, point.y, boundingBox.min.x - 10, point.y); //这里和下面的10都是稍微延长一点点，避免求交失败
                let leftClosestPoint = this.getClosestIntersectPoint(point, leftSeg, leftCalculatedSegArr);
                if (!leftClosestPoint)
                    return [];
                colDimensionArr.push(new dimension_1.Dimension(point, leftClosestPoint, boundingBox.getCenter(), this._drawscale));
                //朝右
                let rightCalculatedSegArr = polygonSegs_local.concat();
                for (let j = i + 1; j < colManager._arr.length; j++) {
                    rightCalculatedSegArr.push(colManager._arr[j].getLineSegment());
                }
                let rightSeg = new LineSegment_js_1.default(point.x, point.y, boundingBox.max.x + 10, point.y);
                let rightClosestPoint = this.getClosestIntersectPoint(point, rightSeg, rightCalculatedSegArr);
                if (!rightClosestPoint)
                    return [];
                colDimensionArr.push(new dimension_1.Dimension(point, rightClosestPoint, boundingBox.getCenter(), this._drawscale));
            }
        }
        this.removeRepetitiveDimension(colDimensionArr, false);
        this.adjustDimensionsToDoor(colDimensionArr, polygonSegs_local, doors_local);
        //转出去前转为世界坐标系
        for (let dimension of colDimensionArr) {
            dimension._point0 = coordinateUtil.transformPointToWorld(dimension._point0);
            dimension._point1 = coordinateUtil.transformPointToWorld(dimension._point1);
            dimension._dim_point = coordinateUtil.transformPointToWorld(dimension._dim_point);
            dimension._text_pos = coordinateUtil.transformPointToWorld(dimension._text_pos);
        }
        return colDimensionArr;
    }
    getClosestIntersectPoint(targetPoint, targetSeg, calculatedSegArr) {
        let intersectPoints = new Array();
        for (let seg of calculatedSegArr) {
            let intersectPoint = targetSeg.intersection(seg);
            if (intersectPoint) {
                intersectPoints.push(intersectPoint);
            }
        }
        if (intersectPoints.length == 0) { //部分异常的多边形会出现这种问题
            return null;
            throw new Error("无交点");
        }
        let minDis = Number.POSITIVE_INFINITY;
        let nearestPoint;
        for (let intersectPoint of intersectPoints) {
            let dis = intersectPoint.distance(targetPoint);
            if (dis < minDis) {
                minDis = dis;
                nearestPoint = intersectPoint;
            }
        }
        return nearestPoint;
    }
    removeRepetitiveDimension(dimensionArr, isRow) {
        for (let i = dimensionArr.length - 1; i > 0; i--) {
            for (let j = i - 1; j >= 0; j--) {
                if (dimensionArr[i].equals(dimensionArr[j], isRow)) {
                    dimensionArr.splice(i, 1);
                    break;
                }
            }
        }
    }
    //调整触碰到门的喷头定位标注
    adjustDimensionsToDoor(dimensions, polygonSegs_local, doors_local) {
        let wallAngles = new Array();
        let walls = new Array();
        for (let seg of polygonSegs_local) {
            let isDoor = false;
            for (let door of doors_local) {
                if (util_1.Util.isTwoSegmentsEquals(seg, door)) {
                    isDoor = true;
                    break;
                }
            }
            if (!isDoor) {
                walls.push(seg);
                wallAngles.push(util_1.Util.computeAngle(seg.p0, seg.p1));
            }
        }
        for (let dimension of dimensions) {
            let dimensionSeg = new LineSegment_js_1.default(dimension._point0, dimension._point1);
            let intersectDoor = undefined;
            for (let door of doors_local) {
                if (door.distance(dimensionSeg) < 1e-3) {
                    intersectDoor = door;
                    break;
                }
            }
            if (intersectDoor == undefined)
                continue;
            //如果标注和门相交，则调整到最近的、角度相等的多边形线段上
            let angle = util_1.Util.computeAngle(intersectDoor.p0, intersectDoor.p1);
            let nearestWall = undefined;
            let minDis = Number.POSITIVE_INFINITY;
            for (let i = 0; i < wallAngles.length; i++) {
                if (Math.abs(angle - wallAngles[i]) < 5) { //5°的容差
                    let seg = walls[i];
                    let dis = seg.distance(intersectDoor);
                    if (dis < 200) { //一般的墙宽度为200，这里容差也设置个200
                        if (dis < minDis) {
                            minDis = dis;
                            nearestWall = seg;
                        }
                    }
                }
            }
            //如果没有符合条件的墙，则不调整了
            if (nearestWall == undefined) {
                //console.error("喷头定位标注调整失败");
                continue;
            }
            //把较近的那个端点调整过去
            //直接用投影点
            let projectPoint = nearestWall.project(dimensionSeg.p0);
            if (projectPoint.distance(dimensionSeg.p0) < projectPoint.distance(dimensionSeg.p1)) {
                dimension._point0.x = projectPoint.x;
                dimension._point0.y = projectPoint.y;
            }
            else {
                dimension._point1.x = projectPoint.x;
                dimension._point1.y = projectPoint.y;
            }
        }
    }
}
exports.DimensionCalculator = DimensionCalculator;
class RowOrColManager {
    constructor(isRow) {
        this._arr = [];
        this._isRow = isRow;
    }
    add(point, value) {
        if (this._arr.length == 0) {
            let newRow = new RowOrCol(value, point, this._isRow);
            this._arr.push(newRow);
        }
        else if (this._arr.length == 1) {
            if (Math.abs(this._arr[0]._value - value) < 1e-4) {
                this._arr[0]._points.push(point);
            }
            else if (value < this._arr[0]._value) {
                let newRow = new RowOrCol(value, point, this._isRow);
                this._arr.splice(0, 0, newRow);
            }
            else {
                let newRow = new RowOrCol(value, point, this._isRow);
                this._arr.push(newRow);
            }
        }
        else {
            for (let row of this._arr) {
                if (Math.abs(row._value - value) < 1e-4) {
                    row._points.push(point);
                    return;
                }
            }
            let min = this._arr[0]._value;
            let max = this._arr[this._arr.length - 1]._value;
            if (value < min) {
                let newRow = new RowOrCol(value, point, this._isRow);
                this._arr.splice(0, 0, newRow);
            }
            else if (value > max) {
                let newRow = new RowOrCol(value, point, this._isRow);
                this._arr.push(newRow);
            }
            else {
                for (let i = 0; i < this._arr.length - 1; i++) {
                    let row1 = this._arr[i];
                    let row2 = this._arr[i + 1];
                    if (value > row1._value && value < row2._value) {
                        let newRow = new RowOrCol(value, point, this._isRow);
                        this._arr.splice(i + 1, 0, newRow);
                        return;
                    }
                }
            }
        }
    }
}
class RowOrCol {
    constructor(value, point, isRow) {
        this._value = value;
        this._points = [point];
        this._isRow = isRow;
    }
    sortPoints() {
        if (this._isRow) {
            this._points.sort(function (a, b) { return a.x - b.x; });
        }
        else {
            this._points.sort(function (a, b) { return a.y - b.y; });
        }
    }
    //获取最小最大点连成的线段（都向外扩大了10，避免求交出问题）
    getLineSegment() {
        //如果是只有一个点的情况，就构造一小段线段
        if (this._points.length == 1) {
            let point = this._points[0];
            if (this._isRow)
                return new LineSegment_js_1.default(point.x - 10, point.y, point.x + 10, point.y);
            else
                return new LineSegment_js_1.default(point.x, point.y - 10, point.x, point.y + 10);
        }
        else {
            if (this._isRow) {
                return new LineSegment_js_1.default(this._points[0].x - 10, this._points[0].y, this._points[this._points.length - 1].x + 10, this._points[this._points.length - 1].y);
            }
            else {
                return new LineSegment_js_1.default(this._points[0].x, this._points[0].y - 10, this._points[this._points.length - 1].x, this._points[this._points.length - 1].y + 10);
            }
        }
    }
}
